var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-camera-player is-preview"},[_c('div',{ref:"player",on:{"dblclick":function($event){$event.stopPropagation();return _vm.onDblClick.apply(null, arguments)}}}),_c('div',{ref:"imgdiv"})])
}
var staticRenderFns = []

export { render, staticRenderFns }